/**
 * 补0
 * @param num
 * @returns {string|*}
 * @constructor
 */
function JoinZero(num) {
    return num < 10 ? '0' + num : num;
}

export default {
    /**
     * 格式化时间
     * @param {Date} date
     * @returns {string}
     */
    formatTime(date) {
        let time = (date ? new Date(date) : new Date());
        let y = time.getFullYear();
        let m = JoinZero(time.getMonth() + 1);
        let d = JoinZero(time.getDate());
        let h = JoinZero(time.getHours());
        let mi = JoinZero(time.getMinutes());
        let s = JoinZero(time.getSeconds());
        return `${y}-${m}-${d} ${h}:${mi}:${s}`;
    },
    /**
     * 格式化日期
     * @param {Date} date
     * @returns {string}
     */
    formatDate(date) {
        let time = (date ? new Date(date) : new Date());
        let y = time.getFullYear();
        let m = JoinZero(time.getMonth() + 1);
        let d = JoinZero(time.getDate());
        return `${y}-${m}-${d}`;
    }
}


// WEBPACK FOOTER //
// ./src/utils/common.js